<template>
  <div class="care-advice">
    <div class="subTit2"><span>农作物管护建议</span></div>
    <div class="advice-grid">
      <CareAdviceCard
        v-for="item in advices"
        :key="item.title"
        :icon="item.icon"
        :title="item.title"
        :desc="item.desc"
      />
    </div>
  </div>
</template>

<script setup>
import CareAdviceCard from "./CareAdviceCard.vue";

const advices = [
  { icon: require("@/assets/img/gb_icon1.png"), title: "水肥管理", desc: "崇礼乡红薯地块墒情偏低，建议滴灌补水并增加钾肥。" },
  { icon: require("@/assets/img/gb_icon2.png"), title: "黄", desc: "东部乡镇小麦长势正常，块茎膨大期及时培土护根。" },
  { icon: require("@/assets/img/gb_icon3.png"), title: "病虫害防控", desc: "蔬菜地块湿度偏高，注意通风排湿，预防霜霉病。" },
  { icon: require("@/assets/img/gb_icon4.png"), title: "小麦一喷防", desc: "东部乡镇小麦进入抽穗扬花期，按照苗情开展一喷三防。" },
];
</script>

<style lang="less" scoped>
.care-advice {
  min-height: 0;
  display: grid;
  grid-template-rows: 66px minmax(0, 1fr);
  gap: 22px;
}

.subTit2 {
  width: 100%;
  height: 66px;
  line-height: 20px;
  padding-left: 40px;
  box-sizing: border-box;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png") no-repeat left bottom;
  font-size: 30px;
  text-align: left;
  color: rgba(254, 254, 254, 1);
}

.advice-grid {
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, 1fr);
  gap: 22px;
}
</style>
